import authorizedInstance from '../../../core/api/authorizedInstance';
import {
  CoachingScheduleRequest,
  CoachingScheduleResponse,
  EditPersonalInfoRequest,
  EditPersonalInfoResponse,
} from '../types/accountSettings';

export const ENROLLMENT_BASE_API_ENDPOINT = '/api/v1/students';

export const postScheduleChangeRequest = (
  memberId: string,
  payload: CoachingScheduleRequest,
  signal?: AbortSignal
) => {
  return authorizedInstance.post<CoachingScheduleResponse>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/request-schedule-change`,
    payload,
    { signal }
  );
};

export const postUpdatePersonalInfo = (
  memberId: string,
  payload: EditPersonalInfoRequest,
  signal?: AbortSignal
) => {
  return authorizedInstance.post<EditPersonalInfoResponse>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/update-personal-info`,
    payload,
    { signal }
  );
};

export const postPauseService = (memberId: string, signal?: AbortSignal) => {
  return authorizedInstance.post<{ statusCode: number, message: string}>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/pause-service`,
    {},
    { signal }
  );
};

export const postEndService = (memberId: string, signal?: AbortSignal) => {
  return authorizedInstance.post<{ statusCode: number, message: string }>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/end-service`,
    {},
    { signal }
  );
};
